var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Button, Grid, IconButton, Typography, useMediaQuery } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid-premium';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { BackFrontCamera, BlackBackFrontCamera } from '../../../assets/images';
import { showLoader, showNotification } from '../../../redux/commonSlice';
import { useAppDispatch } from '../../../store/hooks';
import { MuiButton } from '../../atoms/buttonComponent';
import { MuiImagePopUp } from '../../atoms/imageDialogBox';
import { MuiStack } from '../../atoms/stackComponent';
import { MuiPopup } from '../../molecules/popupComponent';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { getListAPI } from '../../../redux/crudSlice';
import { red } from '../../../theme/palette';
import { secondary } from '../../../theme/colors';
import { GoogleAnlyticsErrorLog, isExeOrJsFile } from '../../../utils/utils';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { Buffer } from "buffer";
export default function ImageCaptureAndFileupload(props) {
    var _this = this;
    var open = props.open, handleModelClose = props.handleModelClose, handleConfirm = props.handleConfirm, isImageEmpty = props.isImageEmpty, clearPopUpImages = props.clearPopUpImages, downloadedImages = props.downloadedImages, systemName = props.systemName, maxImageUploadLimit = props.maxImageUploadLimit, ParentId = props.ParentId, deleteUrl = props.deleteUrl;
    var maxImageLimit = maxImageUploadLimit || 3;
    var webcamRef = useRef(null);
    var fileInputRef = useRef(null);
    // const lgscreen = useMediaQuery('maxWidth:600px')
    var dispatch = useAppDispatch();
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    // const [open, setOpen] = useState(false)
    var _a = useState([]), complaintsPhotographList = _a[0], setcomplaintsPhotographList = _a[1];
    var _b = useState(false), singleImgSelected = _b[0], setSingleImageSelected = _b[1];
    var _c = useState(false), isCaptureEnable = _c[0], setCaptureEnable = _c[1];
    var _d = useState('environment'), facingMode = _d[0], setFacingMode = _d[1];
    var _e = useState([]), imagesUpload = _e[0], setImagesUpload = _e[1];
    var _f = useState(false), isDrawerOpen = _f[0], setISDrawerOpen = _f[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('lg'); });
    var medium = useMediaQuery('(min-width:830px) and (max-width:1024px)');
    var _g = useState(""), imageURL = _g[0], setImageURL = _g[1];
    var videoConstraints = {
        facingMode: facingMode,
        screenshotQuality: 0.2
    };
    useEffect(function () {
        if (downloadedImages && downloadedImages.length > 0) {
            setcomplaintsPhotographList(downloadedImages);
        }
        else {
            setcomplaintsPhotographList([]);
        }
        if (downloadedImages.length >= maxImageLimit) {
            setSingleImageSelected(true);
        }
        else {
            setSingleImageSelected(false);
        }
    }, [downloadedImages]);
    useEffect(function () {
        if (clearPopUpImages) {
            setcomplaintsPhotographList([]);
            setSingleImageSelected(false);
        }
    }, [clearPopUpImages]);
    var handleCancleClick = function () {
        if (complaintsPhotographList.length === 0) {
            handleModelClose(false);
            if (isImageEmpty) {
                isImageEmpty(true);
            }
        }
        else {
            handleModelClose(false);
        }
    };
    var onClickRemovePhotoIcon = function (photoIndex, AttachmentId) { return __awaiter(_this, void 0, void 0, function () {
        var _DeleteAttchementResp, _DeleteAttchementResp2, request, DeleteAttchementResponse, updatedComplaintList, updatedComplaintList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSingleImageSelected(false);
                    if (!AttachmentId) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {
                        SystemName: systemName,
                        ParentId: ParentId,
                        AttachmentId: AttachmentId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deleteUrl,
                            request: request
                        }))];
                case 2:
                    DeleteAttchementResponse = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp === void 0 || (_DeleteAttchementResp = _DeleteAttchementResp.value) === null || _DeleteAttchementResp === void 0 ? void 0 : _DeleteAttchementResp.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp2 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp2 !== void 0 && (_DeleteAttchementResp2 = _DeleteAttchementResp2.value) !== null && _DeleteAttchementResp2 !== void 0 && _DeleteAttchementResp2.success) {
                        updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
                        updatedComplaintList.splice(photoIndex, 1);
                        setcomplaintsPhotographList(updatedComplaintList);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                    }
                    return [3 /*break*/, 5];
                case 4:
                    updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
                    updatedComplaintList.splice(photoIndex, 1);
                    setcomplaintsPhotographList(updatedComplaintList);
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    function dataURLtoFile(dataurl, filename) {
        var _arr$;
        var arr = dataurl.split(','), mime = (_arr$ = arr[0]) === null || _arr$ === void 0 || (_arr$ = _arr$.match(/:(.*?);/)) === null || _arr$ === void 0 ? void 0 : _arr$[1], bstr = atob(arr[arr.length - 1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {
            type: mime
        });
    }
    var capture = function () {
        var _webcamRef$current;
        var imageSrc = (_webcamRef$current = webcamRef.current) === null || _webcamRef$current === void 0 ? void 0 : _webcamRef$current.getScreenshot();
        if (imageSrc) {
            var updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
            var convertedFile = dataURLtoFile(imageSrc, "image-".concat(new Date().toISOString(), ".png"));
            var imageSizeInBytes = convertedFile.size;
            if (imageSizeInBytes > 5 * 1024 * 1024) {
                GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("File size exceeds 5 MB. Please choose a smaller file"));
                dispatch(showNotification({
                    isOpen: true,
                    message: t("File size exceeds 5 MB. Please choose a smaller file"),
                    type: "error"
                }));
                return; // Do not proceed further
            }
            updatedComplaintList.push({
                blobUrl: imageSrc,
                file: convertedFile
            });
            setcomplaintsPhotographList(updatedComplaintList);
            setCaptureEnable(false);
            if (!(updatedComplaintList.length <= maxImageLimit - 1)) {
                setSingleImageSelected(true);
            }
        }
    };
    var handleFileChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var _e$target, allowedExtensions, _i, _a, file, extension, fileSizeInMB, arrayBuffer, buffer, error_1, updatedComplaintList, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    // Check if files exist
                    if (!((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.files) || e.target.files.length === 0) {
                        return [2 /*return*/];
                    }
                    allowedExtensions = ['.png', '.jpeg', '.jpg'];
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    _i = 0, _a = e.target.files;
                    _b.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 6];
                    file = _a[_i];
                    extension = ".".concat(file.name.split('.').pop().toLowerCase());
                    // Check file extension
                    if (!allowedExtensions.includes(extension)) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("Only PNG, JPEG, JPG files are allowed."));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Only PNG, JPEG, JPG files are allowed."),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    fileSizeInMB = file.size / 1024 / 1024;
                    if (fileSizeInMB >= 5) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("File size exceeds 5 MB. Please choose a smaller file"));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("File size exceeds 5 MB. Please choose a smaller file"),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, file.arrayBuffer()];
                case 3:
                    arrayBuffer = _b.sent();
                    buffer = Buffer.from(new Uint8Array(arrayBuffer));
                    if (isExeOrJsFile(buffer)) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("The file format is invalid and not allowed."),
                            type: "error"
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    console.error('Error processing file:', error_1);
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Error processing file. Please try again."),
                        type: "error"
                    }));
                    e.target.value = '';
                    return [2 /*return*/];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6:
                    updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
                    updatedComplaintList.push({
                        file: e.target.files[0],
                        blobUrl: URL.createObjectURL(e.target.files[0])
                    });
                    setcomplaintsPhotographList(updatedComplaintList);
                    // Update single image selection state
                    if (!(updatedComplaintList.length <= maxImageLimit - 1)) {
                        setSingleImageSelected(true);
                    }
                    // Clear the file input
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 8];
                case 7:
                    error_2 = _b.sent();
                    console.error('Error in handleFileChange:', error_2);
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("An error occurred while processing the file."),
                        type: "error"
                    }));
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleConfirmClick = function () {
        handleModelClose(false);
        setImagesUpload(complaintsPhotographList);
        handleModelClose(false);
        handleConfirm(complaintsPhotographList);
    };
    var openCamera = function () {
        if (complaintsPhotographList.length <= maxImageLimit - 1) {
            setCaptureEnable(true);
        }
        else {
            setSingleImageSelected(true);
        }
    };
    var openFileInput = function (e) {
        e.preventDefault();
        if (complaintsPhotographList.length <= maxImageLimit - 1) {
            if (fileInputRef !== null && fileInputRef !== void 0 && fileInputRef.current) {
                fileInputRef.current.click();
            }
        }
        else {
            setSingleImageSelected(true);
        }
    };
    var switchCamera = function () {
        setFacingMode(function (prevFacingMode) { return prevFacingMode === 'user' ? 'environment' : 'user'; });
    };
    var handleClose = function () {
        setImageURL('');
        setISDrawerOpen(false);
    };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: open,
        title: t("Add Photos"),
        variant: "h1",
        onClose: handleCancleClick,
        closeIcon: true,
        containerStyle: {
            padding: "0px",
            width: lgMode ? '500px' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 3,
        direction: 'column',
        paddingX: 3,
        paddingBottom: 3,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: "#8593A3"
        }
    }, t("Please add photos for the complaint"))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            color: red
        }
    }, "*" + t("FILE_SIZE_MESSAGE"))), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "camera",
        name: t('Camera'),
        size: "medium",
        style: {
            border: '1px solid #DEE4EB'
        },
        fullWidth: true,
        onClick: openCamera,
        disabled: singleImgSelected
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "gallary",
        name: t('Gallery'),
        size: "medium",
        style: {
            border: '1px solid #DEE4EB'
        },
        fullWidth: true,
        onClick: openFileInput,
        disabled: singleImgSelected
    })), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 1,
        flexWrap: "wrap",
        justifyContent: 'start',
        alignContent: 'center',
        width: '100%'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        width: '100%',
        bgcolor: 'aqua',
        position: 'relative'
    }, complaintsPhotographList === null || complaintsPhotographList === void 0 ? void 0 : complaintsPhotographList.map(function (item, photoIndex) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        xs: 4,
        key: photoIndex,
        position: 'relative',
        height: '100px',
        width: '100px'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "1st",
        style: {
            display: 'inline-block',
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(GridCloseIcon, {
        onClick: function () { return onClickRemovePhotoIcon(photoIndex, item.AttachmentId); },
        sx: {
            position: 'absolute',
            zIndex: 1,
            right: 4,
            top: 4,
            backgroundColor: "white",
            height: '15px',
            width: '15px',
            borderRadius: 50
        }
    }), /*#__PURE__*/ React.createElement("img", {
        src: item === null || item === void 0 ? void 0 : item.blobUrl,
        id: "downloadCustomerImg" + photoIndex,
        alt: "Image ".concat(photoIndex + 1),
        style: {
            width: '82px',
            height: '82px',
            borderRadius: '15px'
        },
        onClick: function () { return handleClickImage(item === null || item === void 0 ? void 0 : item.blobUrl); }
    }))); })), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2,
        marginTop: 10
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        name: t('Confirm'),
        size: "medium",
        fullWidth: true,
        variant: "contained",
        disabled: (complaintsPhotographList === null || complaintsPhotographList === void 0 ? void 0 : complaintsPhotographList.length) === 0 ? true : false,
        onClick: handleConfirmClick,
        id: "confirmUpload"
    }), /*#__PURE__*/ React.createElement(Button, {
        style: {
            color: "".concat(secondary[600]),
            border: "1px solid ".concat(secondary[200])
        },
        variant: "outlined",
        size: "medium",
        fullWidth: true,
        id: "cancelUpload",
        onClick: handleCancleClick
    }, t('Cancel'), " ")))), isCaptureEnable && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: isCaptureEnable,
        borderRadius: 0,
        containerStyle: {
            padding: '0'
            //  width: medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)' 
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            position: 'relative',
            padding: '0px',
            overflow: 'hidden'
            // width: medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(Webcam, {
        audio: false,
        width: medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)',
        height: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)',
        ref: webcamRef,
        screenshotFormat: "image/jpeg",
        videoConstraints: videoConstraints
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        sx: {
            position: 'absolute',
            // margin: "0",
            padding: '10px',
            bottom: 3,
            backgroundColor: 'white',
            width: "100%"
            // width:  medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: switchCamera
    }, facingMode == "user" ? /*#__PURE__*/ React.createElement("img", {
        src: BlackBackFrontCamera,
        alt: "camera"
    }) : /*#__PURE__*/ React.createElement("img", {
        src: BackFrontCamera,
        alt: "camera"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        gap: '2vw'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        name: t("Close"),
        onClick: function () { return setCaptureEnable(false); }
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        name: t("Capture"),
        onClick: capture
    }))))), /*#__PURE__*/ React.createElement("input", {
        id: "upload-customer-complaint-image",
        type: "file",
        ref: fileInputRef,
        style: {
            display: 'none'
        },
        onChange: handleFileChange,
        accept: "image/*"
    }));
}
